import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Standard from './Standard'

const Postal = props => {
  const {
    validations,
    onChange,
    onBlur,
    value: _value,
    required,
    ...other
  } = props

  const [value, setValue] = useState(_value)

  useEffect(() => {
    setValue(_value)
  }, [_value])

  const handleOnChange = (e, { value }, valid) => {
    const editedValue = edit(value)
    setValue(editedValue)
    onChange(e, { value: editedValue }, isValid(value))
  }

  const handleOnBlur = (e, { value }, valid) => {
    const editedValue = edit(value)
    setValue(editedValue)
    onBlur(e, { value: editedValue }, isValid(value))
  }

  const isValid = val => {
    if (required && (!val || val === '')) return false
    if (!val || val === '') return true

    return val
      .toString()
      .replace(/-/g, '')
      .match(/^[0-9]{7}$/)
      ? true
      : false
  }

  const edit = val => {
    if (!isValid(val)) return val || ''
    if (!val || val === '') return val
    return val
      .toString()
      .replace(/-/g, '')
      .replace(/^(\d{3})(\d{4})$/, '$1-$2')
  }

  return (
    <Standard
      {...other}
      type='tel'
      validations={_.merge({}, validations, {
        isPostal: true,
        maxLength: 8,
      })}
      required={required}
      value={value}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
    />
  )
}

export default Postal

Postal.propTypes = {
  validations: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
}

Postal.defaultProps = {
  validations: {},
  onChange: () => {},
  onBlur: () => {},
  value: '',
  required: false,
}
